// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3RyCA","col":"styles_col__8Ovcd"};